const settings = {
    //url: 'http://localhost:3400/'
    url: 'https://mems-be.nordia.gr/'
}

export default settings;